<template>
  <card body-classes="px-0 pb-1" class="no-border-card" footer-classes="pb-2">
    <template slot="header">
      <h3 v-if="isToLiquidate" class="mb-0">Pedidos A Liquidar</h3>
      <h3 v-else class="mb-0">Pedidos A Cancelar</h3>
    </template>

    <div>
      <div class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
        <el-select v-model="pagination.perPage" class="select-primary pagination-select mt-1" placeholder="Per page">
          <el-option
            v-for="item in pagination.perPageOptions"
            :key="item"
            :label="item"
            :value="item"
            class="select-primary"
          >
          </el-option>
        </el-select>

        <campaign-select v-model="filterCampaign" all-filter="Todas las campañas" :label="null" />

        <div>
          <base-input v-model="mixSearchQuery" class="mt-1" placeholder="Buscar..." prepend-icon="fas fa-search" />
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <el-table :data="queriedData" header-row-class-name="thead-light" @sort-change="sortChange">
        <el-table-column label="Código" min-width="144px" prop="code" sortable>
          <template #default="{ row }">
            {{ row.code }}
          </template>
        </el-table-column>

        <el-table-column label="Fecha" min-width="130px" prop="date" sortable>
          <template #default="{ row }">
            {{ row.date | date('DD/MM/YYYY') }}
          </template>
        </el-table-column>

        <el-table-column label="Productor" min-width="165px" prop="producer" sortable>
          <template #default="{ row }">
            <div v-if="row.producer">
              <router-link
                v-if="$can('show', 'producers')"
                :to="{ name: 'ProducerShow', params: { id: row.producer.id } }"
                class="h5"
              >
                {{ row.producer.businessName }}
              </router-link>
              <p v-else>{{ row.producer.businessName }}</p>
            </div>
            <div v-if="row.producer.distributor">
              <small>{{ row.producer.distributor.name }}</small>
            </div>
            <div v-if="row.producer.distributor.seller">
              <small>{{ row.producer.distributor.seller.name }}</small>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="Campaña" min-width="155px" prop="campaignName" sortable>
          <template #default="{ row }">
            <div>{{ row.campaign.name }}</div>
          </template>
        </el-table-column>

        <el-table-column label="Total (USD)" min-width="167px" prop="total" sortable>
          <template #default="{ row }">
            <div>{{ row.total | toCurrencyUSD }}</div>
          </template>
        </el-table-column>

        <el-table-column label="Total (ARS)" min-width="165px" prop="totalInPesos" sortable>
          <template #default="{ row }">
            <div>{{ row.totalInPesos | toCurrencyARS }}</div>
          </template>
        </el-table-column>

        <el-table-column v-if="!isToLiquidate" label="A Pagar" min-width="150px" prop="to-pay" sortable>
          <template #default="{ row }">
            <div>{{ row.toPay | toCurrencyUSD }}</div>
          </template>
        </el-table-column>

        <div v-if="isToLiquidate">
          <el-table-column label="Total Comisión Distribuidor" min-width="285px" prop="distributorCommission" sortable>
            <template #default="{ row }">
              <div>{{ ((row.totalInPesos / 100) * row.distributorCommission) | toCurrencyARS }}</div>
            </template>
          </el-table-column>
        </div>
        <div v-else>
          <el-table-column label="Cot." min-width="120px" prop="dollarQuote" sortable>
            <template #default="{ row }">
              <div>{{ row.dollarQuote | decimals }}</div>
            </template>
          </el-table-column>
        </div>

        <div v-if="isToLiquidate">
          <el-table-column label="Total Comisión Asesor" min-width="245px" prop="sellerCommission" sortable>
            <template #default="{ row }">
              <div>{{ ((row.totalInPesos / 100) * row.sellerCommission) | toCurrencyARS }}</div>
            </template>
          </el-table-column>
        </div>
        <div v-else>
          <el-table-column label="Dif. Cot." min-width="160px" prop="totalDiff" sortable>
            <template #default="{ row }">
              <div>{{ (row.total * (currentDollarQuotation - row.dollarQuote)) | toCurrencyARS }}</div>
            </template>
          </el-table-column>
        </div>

        <div v-if="isToLiquidate">
          <el-table-column label="Comisión" min-width="155px" prop="commission" sortable>
            <template #default="{ row }">
              <div>{{ row.distributorCommission | decimals }} %</div>
            </template>
          </el-table-column>
        </div>

        <el-table-column v-if="!isToLiquidate" label="Estado" min-width="140px" prop="state" sortable>
          <template #default="{ row }">
            <span v-if="row.receiptsPending === true" class="text-nowrap font-weight-bold">Pendiente Confirmación</span>
            <span v-else class="font-weight-bold">A Cancelar</span>
          </template>
        </el-table-column>

        <el-table-column align="right" label="" min-width="180px">
          <div slot-scope="{ row }" class="d-flex">
            <div v-if="isToLiquidate">
              <router-link
                v-if="$can('index', 'receipts')"
                :to="{ name: 'Liquidate', params: { orderId: row.id } }"
                title="Liquidar"
                class="btn base-button btn-outline-primary btn-sm"
              >
                <i class="fas fa-wallet" />
              </router-link>
            </div>

            <div v-else>
              <router-link
                v-if="$can('store', 'receipts') && row.receiptsPending === false"
                :to="{ name: 'ReceiptCreate', params: { orderId: row.id } }"
                title="Generar recibo"
                class="btn base-button btn-primary btn-sm"
              >
                <i class="far fa-file-alt text-brown" />
              </router-link>
            </div>
          </div>
        </el-table-column>
      </el-table>
    </div>

    <div slot="footer" class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap">
      <div class="">
        <p class="card-category">Mostrando {{ from + 1 }} a {{ to }} de un total de {{ pagination.total }} pedidos</p>
      </div>
      <base-pagination
        v-model="pagination.currentPage"
        :per-page="pagination.perPage"
        :show-first-page-button="true"
        :show-last-page-button="true"
        :total="pagination.total"
        class="pagination-no-border"
        @input="changePage"
      >
      </base-pagination>
    </div>
  </card>
</template>

<script>
import { Table, TableColumn, Select, Option } from 'element-ui';
import { mapGetters } from 'vuex';

import { BasePagination } from '@/components';
import CampaignSelect from '@/components/ModelSelects/CampaignSelect';
import OrderStatesMixin from '@/mixins/orderStatesMixin';
import PaginationOnServerMixin from '@/mixins/paginationOnServerMixin';
import ordersService from '@/services/resources/orders.service';
import moment from 'moment';

export default {
  name: 'ReceiptsOrdersTable',
  components: {
    [Table.name]: Table,
    [TableColumn.name]: TableColumn,
    [Select.name]: Select,
    [Option.name]: Option,
    BasePagination,
    CampaignSelect,
  },

  mixins: [PaginationOnServerMixin, OrderStatesMixin],
  props: {
    campaignId: {
      type: Number,
      default: null,
    },

    orderState: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      tableData: [],
      modelName: 'order',

      filterCampaign: null,
    };
  },

  computed: {
    ...mapGetters('dollarQuotation', ['currentDollarQuotation']),

    currentOrderState() {
      return this.getOrderStateByName(this.orderState);
    },

    isToLiquidate() {
      return this.currentOrderState ? this.currentOrderState.name === ordersService._STATE_TO_LIQUIDATE : false;
    },
  },

  watch: {
    campaignId: {
      handler() {
        this.fetchTableData();
      },
    },

    currentOrderState: {
      immediate: true,
      handler(orderState) {
        if (orderState) {
          this.fetchTableData();
        }
      },
    },

    filterCampaign: {
      handler() {
        this.fetchTableData();
      },
    },
  },

  methods: {
    fetchTableData() {
      this.pagination.perPage = this.perPage || this.pagination.perPage;
      this.pagination.currentPage = this.page || this.pagination.currentPage;

      const params = {
        include: ['producer.distributor.seller', 'campaign'],
        'filter[campaign]': this.campaignId || this.filterCampaign,
        'filter[search]': this.mixSearchQuery,
        'filter[state]': this.currentOrderState.id,
        'filter[createdAfter]': '2024-07-01',
        'filter[campaignsGreaterThan]': 9,
        append: ['total', 'total-in-pesos', 'commission', 'receipts-pending', 'to-pay'],
        perPage: this.pagination.perPage,
        page: this.pagination.currentPage,
        sort: this.sort || this.defaultSort,
      };

      this.$services
        .resource('orders')
        .get(params)
        .then((res) => {
          this.setMeta(res.data.meta);
          return res.data.data;
        })
        .then((data) => (this.tableData = data.orders));
    },
  },
};
</script>

<style scoped>
::v-deep .el-table__expand-column .cell {
  width: 20px;
}

::v-deep .el-table__expanded-cell p {
  word-break: break-word;
  white-space: normal;
}
</style>
